import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    ListButton,
    Show,
    CardActions,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorBoundary from '../ErrorBoundary';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

const HistoryActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/donors'} label="Donors List" />
    </CardActions>
);
export const DonHisListFilter = props => (
    <Filter {...props}>
        
        <DateInput source="updated_date" alwaysOn lable='Date' locales="en-us"/>
    </Filter>
);

export const DonHisList = props => (
    <ErrorBoundary>  
    <List 
        {...props}
        filters={<DonHisListFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'ASC' }}
        bulkActionButtons ={false}
        actions={<HistoryActions/>} 
        title={'Donor History'}
        >
        <Datagrid >
            <DateField source="updated_date" label="Date" locales="en-us"/>  
            <TextField source="message" label="Message"  />
            <TextField source="updated_by" label="Updated by" />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default DonHisList
